import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Splash({ silent }) {
  const nav = useNavigate();
  useEffect(() => {
    if (silent) return;
    const t = setTimeout(() => nav("/login"), 1600);
    return () => clearTimeout(t);
  }, [silent, nav]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-coral to-coral-dark text-white px-6">
      <div className="animate-fade-up flex flex-col items-center">
        <img src="/bitego-icon.png" alt="BiteGoFood" className="w-28 h-28 rounded-3xl shadow-2xl" />
        <h1 className="mt-6 font-display font-extrabold text-4xl tracking-tight">BiteGoFood</h1>
        <p className="text-white/80 text-sm font-medium mt-1">by VS-Solutions</p>
        <p className="mt-4 text-white/95 font-semibold">Food Near You, Faster Than Ever.</p>
      </div>
      {!silent && (
        <div className="absolute bottom-10 flex gap-1.5">
          {[0, 1, 2].map((i) => (
            <span key={i} className="w-2 h-2 rounded-full bg-white/70 animate-bounce" style={{ animationDelay: `${i * 0.15}s` }} />
          ))}
        </div>
      )}
    </div>
  );
}
